enum UserStatus {
  ACTIVE,
  INACTIVE,
}

export default UserStatus;
